import { createSlice } from '@reduxjs/toolkit';
import { act } from 'react-dom/test-utils';
import { useSelector, useDispatch } from 'react-redux';
//import digilockerSuccess from '../../pages/sections/digilockerSuccess';
import {
  RepaymentApi,
  RepaymentApi_extrareducer,
  OffersLearnApi,
  OffersLearnApi_extrareducer,
  OtherProductsApi,
  OtherProductsApi_extrareducer,
  CirApi,
  CirApi_extrareducer,
  DynamicTileApi,
  DynamicTileApi_extrareducer,
} from '../features/api/dashboard-api-calls/index';

const initialState = {
  isInitialRender: true,
  fibeCardActionTypes: [],
  hypervergeKey: null,
  hypervergeId: null,
  profilePic: null,
  showWelcomeScreen: true,
  hasSalary: false,
  userInfo: {
    firstName: null,
    lastName: null,
    profileImage: null,
  },
  repaymentCardApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  offersLearnApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  otherProductsApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  cirApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  dynamicTileApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  loanId: '',
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    updateInitialRender: (state, action) => {
      state.isInitialRender = false;
    },
    updateUserInfo: (state, action) => {
      console.log('userInfo', action.payload);
      state.userInfo = action.payload;
    },
    updateFibeCardActionType: (state, action) => {
      state.fibeCardActionTypes = action.payload;
    },
    updateHypervergeKey: (state, action) => {
      state.hypervergeKey = action.payload;
    },
    updateHasSalary: (state, action) => {
      state.hasSalary = action.payload;
    },
    updateHypervergeId: (state, action) => {
      state.hypervergeId = action.payload;
    },
    updateShowWelcomeScreen: (state, action) => {
      state.showWelcomeScreen = action.payload;
    },
    updateProfilePic: (state, action) => {
      state.profilePic = action.payload;
    },
    updateLoanId: (state, action) => {
      state.loanId = action.payload;
    },
  },
  extraReducers: {
    ...RepaymentApi_extrareducer,
    ...OffersLearnApi_extrareducer,
    ...OtherProductsApi_extrareducer,
    ...CirApi_extrareducer,
    ...DynamicTileApi_extrareducer,
  },
});

export function useDashboardStore() {
  const isInitialRender = useSelector(
    (state) => state.dashboard.isInitialRender
  );
  const userInfo = useSelector((state) => state.dashboard.userInfo);
  const fibeCardActionTypes = useSelector(
    (state) => state.dashboard.fibeCardActionTypes
  );
  const profilePic = useSelector((state) => state.dashboard.profilePic);
  const hypervergeKey = useSelector((state) => state.dashboard.hypervergeKey);
  const hasSalary = useSelector((state) => state.dashboard.hasSalary);
  const hypervergeId = useSelector((state) => state.dashboard.hypervergeId);
  const showWelcomeScreen = useSelector(
    (state) => state.dashboard.showWelcomeScreen
  );
  const repaymentCardApiState = useSelector(
    (state) => state.dashboard.repaymentCardApiState
  );
  const offersLearnApiState = useSelector(
    (state) => state.dashboard.offersLearnApiState
  );
  const otherProductsApiState = useSelector(
    (state) => state.dashboard.otherProductsApiState
  );
  const cirApiState = useSelector((state) => state.dashboard.cirApiState);
  const dynamicTileApiState = useSelector(
    (state) => state.dashboard.dynamicTileApiState
  );
  const loanId = useSelector((state) => state.dashboard.loanId);

  const dispatch = useDispatch();

  return {
    // state
    isInitialRender,
    userInfo,
    fibeCardActionTypes,
    hypervergeKey,
    profilePic,
    hypervergeId,
    hasSalary,
    showWelcomeScreen,
    repaymentCardApiState,
    offersLearnApiState,
    otherProductsApiState,
    cirApiState,
    dynamicTileApiState,
    loanId,
    // reducers
    updateInitialRender: () => dispatch(updateInitialRender()),
    updateUserInfo: (payload) => dispatch(updateUserInfo(payload)),
    updateFibeCardActionType: (payload) =>
      dispatch(updateFibeCardActionType(payload)),
    updateHypervergeKey: (payload) => dispatch(updateHypervergeKey(payload)),
    updateHasSalary: (payload) => dispatch(updateHasSalary(payload)),
    updateHypervergeId: (payload) => dispatch(updateHypervergeId(payload)),
    updateProfilePic: (payload) => dispatch(updateProfilePic(payload)),
    updateShowWelcomeScreen: (payload) =>
      dispatch(updateShowWelcomeScreen(payload)),
    // api_calls
    RepaymentApi: (payload) => dispatch(RepaymentApi(payload)),
    OffersLearnApi: (payload) => dispatch(OffersLearnApi(payload)),
    OtherProductsApi: (payload) => dispatch(OtherProductsApi(payload)),
    CirApi: (payload) => dispatch(CirApi(payload)),
    DynamicTileApi: (payload) => dispatch(DynamicTileApi(payload)),
    updateLoanId: (payload) => dispatch(updateLoanId(payload)),
  };
}

export const {
  updateInitialRender,
  updateUserInfo,
  updateFibeCardActionType,
  updateHypervergeId,
  updateHypervergeKey,
  updateProfilePic,
  updateHasSalary,
  updateShowWelcomeScreen,
  updateLoanId,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
